export default {
  setSuperUserXStreams(state, payload) {
    state.superUserXStreams = payload;
  },
  setSuperUserXStreamRules(state, payload) {
    state.superUserXStreamRules = payload;
  },
  setSuperUserXStreamLastStatus(state, payload) {
    state.superUserXStreamLastStatus = payload;
  },
};
